import React, { useState } from 'react'
import { format } from 'date-fns'
import { getSomeArticles } from '../../data/news'

import Link from 'next/link'
import LazyImage from '../LazyImage'

export default function NewsColumns (props) {
  const [newsPosts, setNewsPosts] = useState(props.articlesPosts.json)
  const [currentPage, setPage] = useState(0)
  const [isLoading, setIsLoading] = useState(false)

  // create array from 0 to maxPages
  const pages = [...Array(props.articlesPosts.maxPages).keys()]

  const getMoreNewsPosts = async pageNumber => {
    if (isLoading) return
    setIsLoading(true)
    setPage(pageNumber - 1)
    const newPosts = await getSomeArticles(pageNumber)
    await setNewsPosts(newPosts.json)
    setIsLoading(false)
  }

  const divStyle = src => ({
    backgroundImage: 'url(' + src + ')'
  })

  const renderPagination = () => (
    <div className='pagination spacer'>
      <div
        className='d-flex justify-content-left page-numbers'
        style={{ paddingTop: 10 }}
      >
        {/*<img alt='Previous' src='/left.svg' height='18' width='18' />*/}
        {pages.map(pageNo =>
          pageNo === currentPage ? (
            <span
              key={pageNo}
              aria-current='page'
              className='page-numbers current'
            >
              {pageNo + 1}
            </span>
          ) : (
            <a
              key={pageNo}
              className='page-numbers'
              style={{ cursor: 'pointer' }}
              onClick={() => getMoreNewsPosts(pageNo + 1)}
            >
              {pageNo + 1}
            </a>
          )
        )}
        {/*<img alt='Next' src='/right.svg' height='18' width='18' />*/}
      </div>
    </div>
  )

  const renderArticles = items =>
    items.map(data => {
      if (data._embedded['wp:featuredmedia']) {
        var bgImage = data._embedded['wp:featuredmedia'][0].source_url
      } else {
        var bgImage = '/public-next/images/quell-placeholder.png'
      }
      return (
        <div
          key={data.id}
          className='article row'
          aria-labelledby={`article-${data.id}`}
        >
          <LazyImage
            background
            containClass='article-img-container col-12 col-md align-self-center'
            imageClass=' article-img'
            src={bgImage}
            alt=''
          ></LazyImage>

          <div className='article-body col-10 col-md d-flex flex-column justify-content-between'>
            <div>
              <p className='date'>
                {format(new Date(data.date), 'MMMM d, yyyy')}
              </p>
              <p
                dangerouslySetInnerHTML={{ __html: data.title.rendered }}
                className='article-heading'
                id={`article-${data.id}`}
              ></p>
            </div>
            <div>
              <Link as={`/news/${data.slug}`} href='/news/[slug]' passHref>
                <a className='link'>
                  Read more
                  <span
                    className='sr-only'
                    dangerouslySetInnerHTML={{ __html: data.title.rendered }}
                  />
                </a>
              </Link>
            </div>
          </div>
        </div>
      )
    })

  const renderPress = items =>
    items.map(item => {
      return (
        <div
          key={item.id}
          className='col-10 offset-1 offset-md-0 col-md-6 col-lg-12 news-wrapper'
        >
          <p className='date'>{format(new Date(item.date), 'MMMM d, yyyy')}</p>
          <p>
            <a
              className='press-heading'
              href={`${item.content.rendered.replace(/(<([^>]+)>)/gi, '')}`}
              target='_blank'
              rel='noopener'
              dangerouslySetInnerHTML={{ __html: item.title.rendered }}
            />
          </p>
        </div>
      )
    })

  return (
    <React.Fragment>
      <a className='skip' id='skip'></a>
      <div
        className='container-fluid news'
        style={{ opacity: isLoading ? 0.5 : 1, transition: 'opacity 0.25s' }}
      >
        {/*.animate*/}
        <div
          className='row slide-up justify-content-center'
          style={{ paddingTop: 0 }}
        >
          <div className='col-12 col-md articles'>
            <div className='row'>
              <div className='col-10 offset-1 offset-md-0 col-md news-wrapper'>
                <h2 className='news-heading'>Articles</h2>
              </div>
            </div>
            {renderArticles(newsPosts)}
            {renderPagination()}
          </div>
          {/*.articles .col-12*/}

          <div className='col-12 col-md press'>
            <div className='row'>
              <div className='col-10 offset-1 offset-md-0 col-md'>
                <h3 className='news-heading'>Press</h3>
              </div>
              {/*.col-10*/}
            </div>
            {/*.row*/}

            <div className='row'>
              {renderPress(props.pressPosts)}

              <div className='col-10 offset-1 offset-md-0 col-lg-12 news-wrapper last'>
                <a href='/press' className='link' aria-label='Press Page'>
                  View More
                  <span className='sr-only'>Press Articles</span>
                </a>
              </div>
              {/*.col-10*/}
            </div>
            {/*.row*/}
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}
